module.exports = __webpack_public_path__ + "static/media/CAMFT-Logo.358dbb1a.png";